import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ComponentsModule } from '../components/components.module';
import { ChildComponentsModule } from '../components/child-components.module';
import { NotFoundComponent } from './not-found.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule} from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select';
import { CommonChildComponentsModule } from '../components/common-components.module'
export const routes:any[] = [
  {
    path: '', component: NotFoundComponent
  },
];


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ChildComponentsModule,
    CommonChildComponentsModule,
ComponentsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule
  ],
  declarations: [
    NotFoundComponent
  ],


})
export class NotFoundModule { }